<template>
  <div class="geturl">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="">
            <router-link to="/home/cloudDisk">我的云盘</router-link>
          </li>
          <li class="active"><a href="javascript:void(0);">下载链接导出</a> </li>
        </ul>
      </nav>
    </div>
    <div class="search">
      <span>数据类型:</span>
      <el-cascader :options="datainfos" :props="props" collapse-tags clearable v-model="selectedOptions" size="small"
        :show-all-levels="false">
      </el-cascader>
      <span>数据时间:</span>
      <el-date-picker v-model="productdate" value-format="yyyy-MM-dd" type="daterange" align="right" unlink-panels
        size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
      <span class="btn-srarch" @click="getExportLinks">导出</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'getUrl',
  components: {
  },
  data () {
    return {
      input: '',
      value: '',
      productdate: '',
      selectedOptions: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      props: { multiple: true },
      prodata: [],
      datainfos: []
    }
  },
  created () {
    this.initclassdata()
    this.resdatainfo()
  },
  methods: {
    getCsv (url) {
      if (url === '' || url === undefined || url.length === 0) {
        this.$message({
          message: '没有相关数据下载链接',
          type: 'warning'
        })
        return
      }
      var urldata = ''
      url.forEach((type, index) => {
        urldata = urldata + type.fileName + ',' + type.fileCheckMethod + ',' + type.md5 + ',' + type.downloadUrl + ',' + type.productDate + ',' + type.fileModifyDate + ',' + type.orderCode + '\n'
      })
      var universalBOM = '\uFEFF'
      var uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM) + '文件名,校验方式,校验码,下载链接,数据时间,平台下载时间,所属订单\n' + urldata
      var downloadLink = document.createElement('a')
      downloadLink.href = uri
      downloadLink.download = '下载链接导出.csv'
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
      this.$message.success('下载链接导出成功！')
    },
    getExportLinks () {
      var code = []
      if (this.selectedOptions === '' || this.selectedOptions === undefined || this.selectedOptions.length === 0) {
        this.$message({
          message: '请选择数据类型',
          type: 'warning'
        })
        return
      }
      this.selectedOptions.forEach((type, index) => {
        code.push(type[2])
      })
      var startDate = ''
      var endDate = ''
      if (this.productdate) {
        startDate = this.productdate[0]
        endDate = this.productdate[1]
      } else {
        this.$message({
          message: '请选择数据时间',
          type: 'warning'
        })
        return
      }
      let queryParam = {
        codes: code,
        startDate: startDate,
        endDate: endDate
      }
      this.sapost('/dmc/account/getExportLinks', queryParam, r => {
        let { myCloudDisks } = r.data
        this.getCsv(myCloudDisks)
      })
    },
    initclassdata: function () {
      // 分类查询条件 维度(1应用领域2卫星)
      var josndata = {
        dimension: 2,
        appfieldcode: 0
      }
      this.sapost('/dmc/catalog/catalogs', josndata, r => {
        this.prodata = r.data
      })
    },
    // 产品分类数据处理
    resdatainfo: function () {
      var onelevelinfos = []
      this.prodata.forEach((item, index) => {
        if (item.level === 2) {
          var t = true
          onelevelinfos.forEach((itemo, indexo) => {
            if (itemo.appliedfielid === item.appliedfielid) {
              t = false
            }
          })
          if (t) {
            var jobtwo = []
            this.prodata.forEach((itemj, indexj) => {
              if (itemj.level === 2 && itemj.appliedfielid === item.appliedfielid) {
                var jobthree = []
                this.prodata.forEach((itemk, indexk) => {
                  if (itemk.level === 3 && itemk.appliedfielid === itemj.product_type_code) {
                    var jkl = {
                      label: itemk.product_name,
                      product_type_code: itemk.product_type_code,
                      appliedfielid: itemk.appliedfielid,
                      value: itemk.code,
                      checkAll: false
                    }
                    jobthree.push(jkl)
                  }
                })
                var slk = {
                  label: itemj.product_name,
                  product_type_code: itemj.product_type_code,
                  appliedfielid: itemj.appliedfielid,
                  value: itemj.code,
                  checkAll: false,
                  children: jobthree
                }
                jobtwo.push(slk)
              }
            })
            var jobone = {
              label: item.appliedfieldname,
              appliedfielid: item.appliedfielid,
              value: item.code,
              children: jobtwo
            }
            onelevelinfos.push(jobone)
          }
        }
      })
      this.datainfos = onelevelinfos
    }
  },
  watch: {
    prodata: function (data) {
      this.resdatainfo()
    }
  }
}
</script>

<style lang="less">
.geturl {
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  min-height: 150px;
  .t-nav {
    nav {
      border-bottom: 2px solid #ddd;
      ul {
        height: 60px;
        color: #b4b8bb;
        li {
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a {
            color: #b4b8bb;
          }
        }
        li.active {
          border-bottom: 2px solid #f01400;
          a {
            color: #f01400;
          }
        }
        li:hover {
          border-bottom: 2px solid #f97575;
          a {
            color: #f97575;
          }
        }
      }
    }
  }
  .search {
    padding-left: 10px;
    margin-top: 25px;
    text-align: left;
    font-size: 14px;
    margin-bottom: 10px;
    .el-date-editor {
      width: 320px;
    }
    .el-cascader {
      width: 265px;
      .el-input__inner {
        width: 230px;
        height: 32px !important;
      }
      .el-cascader__tags {
        height: 30px;
        .el-tag {
          height: 27px;
        }
      }
    }
    .el-select {
      width: 260px;
      .el-input__inner {
        padding-right: 10px;
        width: 260px;
      }
    }
    .el-input {
      width: 250px;
    }
    .el-date-editor {
      .el-icon-date {
        position: absolute;
        right: 1px;
        top: 2px;
      }
    }
    span,
    .el-date-editor,
    .el-select {
      margin-right: 10px;
    }
    span.btn-srarch {
      display: inline-block;
      padding: 0 15px;
      line-height: 32px;
      height: 32px;
      background-color: #f14242;
      margin-left: 20px;
      color: #fbdfdd;
      cursor: pointer;
      margin-right: 0px;
    }
  }
  .el-table__body {
    .download {
      color: red;
    }
  }
  .pages {
    text-align: right;
    padding-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/geturl.vue